import { autoserialize, autoserializeAs } from 'cerialize';

export class CachedData {
  @autoserialize
  data: string;

  @autoserializeAs(Date)
  expiry: Date;
}
